import React, { useState } from 'react';

function ChevronDownIcon() {
	return (
		<svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 0.502197L8 8.5022L16 0.502197H14.4L8 6.9022L1.6 0.502197H0Z"
				fill="black"
			/>
		</svg>
	);
}

function ChevronUpIcon() {
	return (
		<svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 8.50214L8 0.502136L0 8.50214H1.6L8 2.10214L14.4 8.50214H16Z"
				fill="black"
			/>
		</svg>
	);
}

function SolidDownIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="5" viewBox="0 0 12 5" fill="none">
			<path d="M1.88584 0L0.5 0.00301734L6.0059 5L11.5 0.00301734L1.88584 0Z" fill="black" />
		</svg>
	);
}

function SolidUpIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
			<path
				d="M2.88584 10.5L1.5 10.497L7.0059 5.5L12.5 10.497H11.1302L2.88584 10.5Z"
				fill="black"
			/>
		</svg>
	);
}

export default function ToggleBlock({
	title,
	showDetailsInitially = false,
	fieldSetIsOptionalText,
	isFieldsetRequired,
	iconStyle = 'default',

	groupControlledToggle: externalIsOpen,
	groupController: externalToggle,

	children,
}) {
	const [internalIsOpen, setInternalIsOpen] = useState(showDetailsInitially);

	const isOpen = typeof externalIsOpen === 'boolean' ? externalIsOpen : internalIsOpen;

	const toggle = () => (externalToggle || setInternalIsOpen)(!isOpen);

	const UpIcon = iconStyle === 'solid' ? SolidUpIcon : ChevronUpIcon;
	const DownIcon = iconStyle === 'solid' ? SolidDownIcon : ChevronDownIcon;

	return (
		<div className="transportation-amenities-toggle-block">
			<button
				type="button"
				onClick={toggle}
				className="transportation-amenities-toggle-block__container"
			>
				<div className="transportation-amenities-toggle-block__condensed-item">
					<div>
						{typeof title === 'string' ? (
							<h4 className="ty-c1">
								{title}
								{fieldSetIsOptionalText && (
									<span
										className="ty-c4
                      transportation-amenities-toggle-block__optional-text"
									>
										{fieldSetIsOptionalText}
									</span>
								)}
								{isFieldsetRequired && <span>*</span>}
							</h4>
						) : (
							title
						)}
					</div>

					{isOpen ? (
						<div className="transportation-amenities-toggle-block__chevron-icon">
							<UpIcon />
						</div>
					) : (
						<div className="transportation-amenities-toggle-block__chevron-icon">
							<DownIcon />
						</div>
					)}
				</div>
			</button>

			{isOpen && <div>{children}</div>}
		</div>
	);
}
